import { Component } from "react";

// Isolates optional sections (e.g. portfolio) so their failure never blanks the page.
export class SafeBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error(`[${this.props.name || "section"}] failed to render`, error);
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
